import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full w-full" }
const _hoisted_2 = { class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden" }
const _hoisted_3 = { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600 flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tạo nhóm chat tự động theo lớp bán trú"),
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z",
      stroke: "#A8C1DE",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.25511 5.78615C5.24752 5.92237 5.3599 6.03271 5.49634 6.03271H6.32082C6.45889 6.03271 6.56868 5.92013 6.58723 5.78331C6.67618 5.12718 7.1265 4.64893 7.92922 4.64893C8.61477 4.64893 9.24318 4.9917 9.24318 5.81689C9.24318 6.45166 8.86867 6.74365 8.27834 7.18799C7.60549 7.67676 7.07229 8.24805 7.11037 9.1748L7.11334 9.39161C7.11521 9.52833 7.22658 9.63818 7.36332 9.63818H8.17434C8.31241 9.63818 8.42434 9.52625 8.42434 9.38818V9.28271C8.42434 8.56543 8.69729 8.35596 9.43361 7.79736C10.043 7.33398 10.6778 6.81982 10.6778 5.74072C10.6778 4.22998 9.40188 3.5 8.00539 3.5C6.73831 3.5 5.34964 4.09061 5.25511 5.78615ZM6.81203 11.5488C6.81203 12.082 7.23732 12.4756 7.82131 12.4756C8.43068 12.4756 8.84963 12.082 8.84963 11.5488C8.84963 10.9966 8.43068 10.6094 7.82131 10.6094C7.23732 10.6094 6.81203 10.9966 6.81203 11.5488Z",
      fill: "#A8C1DE"
    })
  ])
], -1)
const _hoisted_5 = { class: "text-neutral-500 font-normal leading-5 text-sm mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "__section__content" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal uppercase text-xs" }, " tính năng tạo nhóm chat tự động theo lớp bán trú ", -1)
const _hoisted_11 = { class: "mt-10 __setup-target-smart __section shadow-sm bg-white overflow-hidden" }
const _hoisted_12 = { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600 flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tạo nhóm chat tự động theo lớp nhóm"),
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z",
      stroke: "#A8C1DE",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.25511 5.78615C5.24752 5.92237 5.3599 6.03271 5.49634 6.03271H6.32082C6.45889 6.03271 6.56868 5.92013 6.58723 5.78331C6.67618 5.12718 7.1265 4.64893 7.92922 4.64893C8.61477 4.64893 9.24318 4.9917 9.24318 5.81689C9.24318 6.45166 8.86867 6.74365 8.27834 7.18799C7.60549 7.67676 7.07229 8.24805 7.11037 9.1748L7.11334 9.39161C7.11521 9.52833 7.22658 9.63818 7.36332 9.63818H8.17434C8.31241 9.63818 8.42434 9.52625 8.42434 9.38818V9.28271C8.42434 8.56543 8.69729 8.35596 9.43361 7.79736C10.043 7.33398 10.6778 6.81982 10.6778 5.74072C10.6778 4.22998 9.40188 3.5 8.00539 3.5C6.73831 3.5 5.34964 4.09061 5.25511 5.78615ZM6.81203 11.5488C6.81203 12.082 7.23732 12.4756 7.82131 12.4756C8.43068 12.4756 8.84963 12.082 8.84963 11.5488C8.84963 10.9966 8.43068 10.6094 7.82131 10.6094C7.23732 10.6094 6.81203 10.9966 6.81203 11.5488Z",
      fill: "#A8C1DE"
    })
  ])
], -1)
const _hoisted_14 = { class: "text-neutral-500 font-normal leading-5 text-sm mt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "__section__content" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal uppercase text-xs" }, " tính năng tạo nhóm chat tự động theo lớp nhóm ", -1)
const _hoisted_20 = { class: "mt-10 __setup-target-smart __section shadow-sm bg-white overflow-hidden" }
const _hoisted_21 = { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600 flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Quản lý thành viên nhóm chat"),
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z",
      stroke: "#A8C1DE",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.25511 5.78615C5.24752 5.92237 5.3599 6.03271 5.49634 6.03271H6.32082C6.45889 6.03271 6.56868 5.92013 6.58723 5.78331C6.67618 5.12718 7.1265 4.64893 7.92922 4.64893C8.61477 4.64893 9.24318 4.9917 9.24318 5.81689C9.24318 6.45166 8.86867 6.74365 8.27834 7.18799C7.60549 7.67676 7.07229 8.24805 7.11037 9.1748L7.11334 9.39161C7.11521 9.52833 7.22658 9.63818 7.36332 9.63818H8.17434C8.31241 9.63818 8.42434 9.52625 8.42434 9.38818V9.28271C8.42434 8.56543 8.69729 8.35596 9.43361 7.79736C10.043 7.33398 10.6778 6.81982 10.6778 5.74072C10.6778 4.22998 9.40188 3.5 8.00539 3.5C6.73831 3.5 5.34964 4.09061 5.25511 5.78615ZM6.81203 11.5488C6.81203 12.082 7.23732 12.4756 7.82131 12.4756C8.43068 12.4756 8.84963 12.082 8.84963 11.5488C8.84963 10.9966 8.43068 10.6094 7.82131 10.6094C7.23732 10.6094 6.81203 10.9966 6.81203 11.5488Z",
      fill: "#A8C1DE"
    })
  ])
], -1)
const _hoisted_23 = { class: "text-neutral-500 font-normal leading-5 text-sm mt-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "__section__content" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal uppercase text-xs" }, " Quản lý thành viên nhóm chat ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopupConfirm = _resolveComponent("PopupConfirm")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PopupConfirm, {
          "is-off": 
				_ctx.type === 0
					? !_ctx.has_day_care_chat_group
					: !_ctx.has_group_class_chat_group
			,
          type: _ctx.type,
          onClose: _ctx.cancel,
          onSubmit: _ctx.onSubmit
        }, null, 8, ["is-off", "type", "onClose", "onSubmit"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(" Việc bật sẽ cho phép hệ thống tạo nhóm chat tự động theo lớp bán trú. Nhóm chat sẽ luôn bao gồm các quản lý, " + _toDisplayString(_ctx.$filters.terminology('teacher')) + " bán trú và phụ huynh của các học sinh trong lớp. ", 1),
            _hoisted_6,
            _createTextVNode("Việc tắt tính năng sẽ vô hiệu hóa các nhóm chat bán trú hiện có, và hệ thống sẽ không thể tự động tạo nhóm chat theo lớp bán trú trong tương lai. Bạn vẫn sẽ xem được thông tin cũ của các nhóm bán trú. ")
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_SwitchButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOpenModal(0))),
                value: _ctx.has_day_care_chat_group
              }, null, 8, ["value"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createTextVNode(" Việc bật sẽ cho phép hệ thống tạo nhóm chat tự động theo lớp nhóm. Nhóm chat sẽ luôn bao gồm các quản lý, " + _toDisplayString(_ctx.$filters.terminology('teacher')) + " phụ trách lớp nhóm và phụ huynh của các học sinh trong lớp. ", 1),
            _hoisted_15,
            _createTextVNode(" Tắt tính năng sẽ vô hiệu hóa các nhóm chat của lớp nhóm hiện có, và hệ thống sẽ không thể tự động tạo nhóm chat theo lớp nhóm trong tương lai. Bạn vẫn sẽ xem được thông tin cũ của các lớp nhóm. ")
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_SwitchButton, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenModal(1))),
                value: _ctx.has_group_class_chat_group
              }, null, 8, ["value"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createTextVNode(" Tính năng này cho phép Quản lý thêm/bớt thành viên trong các nhóm chat."),
            _hoisted_24,
            _createTextVNode(" Ở chế độ mặc định (tắt), nhóm chat sẽ bao gồm toàn bộ " + _toDisplayString(_ctx.$filters.terminology('teacher')) + ", Quản lý và Phụ huynh. ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_SwitchButton, {
                value: _ctx.enable_chat_group_users_management,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.enable_chat_group_users_management) = $event))
              }, null, 8, ["value"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}